import React from 'react';
import { createRoot } from 'react-dom/client';
import AuthoritySearch from './react/AuthoritySearch';
import ErrorBoundary from '../../../javascripts/utils/ErrorBoundary';

const getItemsFromScript = async ($script) => {
  if (!$script) {
    return [];
  }
  const json = await JSON.parse($script.textContent);

  if (!json || json.length === 0) {
    console.error('No data found in authority-search__data');
    return [];
  }

  return json;
};

const initAuthoritySearch = async ($el) => {
  const $wrap = document.createElement('div');
  $wrap.classList.add('authority-search__wrap');
  $el.appendChild($wrap);
  const $script = $el.querySelector('.authority-search__data');
  const $alert = $el.querySelector('.authority-search__alert');
  const data = (await getItemsFromScript($script)) || [];
  const root = createRoot($wrap);
  // TODO fallback component
  root.render(
    <ErrorBoundary>
      <AuthoritySearch {...data} />
    </ErrorBoundary>
  );
  $script?.remove();
  $alert?.remove();
};

document
  .querySelectorAll('.authority-search')
  .forEach(($tax) => initAuthoritySearch($tax));
